module.exports = __webpack_public_path__ + "static/img/13.19fe6bf9.png";